import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectEventStreamingService {

  private _endPoints = {
    getEventStreamConnections: 'api/ExternalSystem/EventStream',
    getEventStreamConfiguration: 'api/ExternalSystem/EventStream',
    testEventStreamConnection: 'api/ExternalSystem/EventStream/Test',
    updateEventStreamConfiguration: 'api/ExternalSystem/EventStream'
  };

  constructor(private _restApi: RestApi) { }

  /**
   * Get all Event Stream connections (only displayName and description)
   */
  public getEventStreamConnections(): Promise<IEventStreamType[]> {
    return this._restApi.get(this._endPoints.getEventStreamConnections).toPromise() as Promise<IEventStreamType[]>;
  }

  /**
   * Get full Event Stream configuration details by ID
   * @param id GUID of EventStreamingConfiguration
   */
  public getEventStreamConfiguration(id: string): Promise<IEventStreamingEvent> {
    return this._restApi.get(`${this._endPoints.getEventStreamConfiguration}/${id}`).toPromise() as Promise<IEventStreamingEvent>;
  }

  /**
   * Test Event Stream connection
   * @param connection EventStreamConnection object
   */
  public testEventStreamConnection(connection: IKafkaConnection): Promise<IEventStreamingTestResponse> {
    return this._restApi.post(this._endPoints.testEventStreamConnection, connection).toPromise() as Promise<IEventStreamingTestResponse>;
  }

  /**
   * Update Event Stream configuration
   * @param configuration Full EventStreamingConfiguration object
   */
  public updateEventStreamConfiguration(configuration: IEventStreamingEvent): Promise<boolean> {
    return this._restApi.put(this._endPoints.updateEventStreamConfiguration, configuration).toPromise() as Promise<boolean>;
  }
}
